<template>
<footer>
  <div class="footer-inner">
    <div class="footer-links">
      <a target="_blank" rel="noopener noreferrer" href="https://ftw-robotics.ai/">FTW ROBOTICS.AI</a>
      <span class="divider">|</span>
      <a target="_blank" rel="noopener noreferrer" href="https://ftw-robotics.ai/platform.html">BFC Platform</a>
      <span class="divider">|</span>
      <a target="_blank" rel="noopener noreferrer" href="https://ftw-robotics.ai/contact.html">Support</a>
    </div>
    <div class="footer-copy">&copy;FTW Robotics 2026</div>
  </div>
</footer>
</template>

<script>
export default {
  name: 'FooterComponent',
  data() { return {} }
}
</script>

<style scoped>
footer {
  background-color: #0a0a0a;
  border-top: 1px solid #1a1a1a;
  padding: 16px 20px;
}
.footer-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
}
.footer-links a {
  color: #aaa;
  text-decoration: none;
  font-family: 'Montserrat', sans-serif;
  font-size: 12px;
  letter-spacing: 0.05em;
  text-transform: uppercase;
}
.footer-links a:hover { color: #7ab648; }
.divider { color: #444; margin: 0 8px; }
.footer-copy {
  color: #555;
  font-family: 'Montserrat', sans-serif;
  font-size: 11px;
}
</style>
